import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import HttpService from '../services/httpService';
import { useHistory } from 'react-router-dom';
import '../App.css'
import ReCAPTCHA from 'react-google-recaptcha';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import decorpotLogo from "../assets/img/org/decorpot_new_logo.png";
import { SpecificUserCategory } from '../utils/index';
const JobIvrsForm = (props) => {
    const history = useHistory();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile: '',
        interestedRole: '',
        cvAttachment: ''
    });
    const [storeSpecificUserDetails, setSpecificUserDetails] = useState([]);
    const [toggleForm, setToggleForm] = useState(false);
    const [captchaValue, setCaptchaValue] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        // Allow only letters, spaces, hyphens, and apostrophes in the 'name' field
        if (name === 'name' && !/^[a-zA-Z\s'-]*$/.test(value)) {
            return;
        }
    
        // Allow only numbers in the 'mobile' field
        if (name === 'mobile' && !/^\d*$/.test(value)) {
            return;
        }
    
        setFormData({
            ...formData,
            [name]: value
        });
    };
    

    const onImageChange = async (e) => {
        props.setLoading(true);
        const fd = new FormData();
        fd.append('file', e.target.files[0]);
        fd.append('customerName', formData.name + '_' + formData.email);

        try {
            const fileUploadRes = await HttpService.uploadFile(fd);
            setFormData({
                ...formData,
                cvAttachment: fileUploadRes.data
            });
            props.setSnackInfo('File uploaded successfully!', 'success');
        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? 'Something went wrong', 'error');
        }
        props.setLoading(false);
    };

    const validateForm = () => {
        const { name, email, mobile, interestedRole } = formData;
        if (!name || !email || !mobile || !interestedRole) {
            props.setSnackInfo('All fields are required!', 'error');
            return false;
        }
        if (name.trim().length < 3|| interestedRole.trim().length < 3) {
            props.setSnackInfo('Details Should more than 3 Letter', 'error');
            return false;
        }
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!email || !emailRegex.test(email)) {
            props.setSnackInfo('Please enter a valid email address', 'error');
            return false;
        }
        const phoneRegex = /^[0-9]{10}$/;
        if (!mobile || !phoneRegex.test(mobile)) {
            props.setSnackInfo('Phone number should be exactly 10 digits', 'error');
            return false;
        }

        return true;
    };

  

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!captchaValue) {
            props.setSnackInfo('Please complete the CAPTCHA', 'error');
            return;
        }
    // Validate form fields
    if (!validateForm()) {
        return;
    }

        const { departmentId, teamId, _id, name, email } = storeSpecificUserDetails[0] || {};
        const dataToSend = {
            assignedDepartment: departmentId,
            assignedTeam: teamId,
            email: email,
            category: SpecificUserCategory.jobCategory,
            assignedTo: { _id, name, email },
            status: 'Pending',
            otherProjectDetails: {
                name: formData.name,
                email: formData.email,
                mobile: formData.mobile,
                interestedRole: formData.interestedRole,
                cvAttachment: formData.cvAttachment
            }
        };

        try {
            props.setLoading(true);
            const response = await HttpService.submitJobRelatedForm(dataToSend);
            props.setSnackInfo('Form Submitted Successfully', 'success');
            localStorage.setItem('formFilledForJob', JSON.stringify(true)); // Set form status in localStorage
            history.push('/thank-you');
        } catch (error) {
            props.setSnackInfo('Something Went Wrong', 'error');
        } finally {
            props.setLoading(false);
        }
    };

    const getUserDetails = async () => {
        try {
            let res = await HttpService.getUserForWhatsAppMessage();
            setSpecificUserDetails(res.data['Recruiter']);
        } catch (error) {
            props.setSnackInfo('Failed to fetch user details', 'error');
        }
    };

    useEffect(() => {
        getUserDetails();
    }, []);


    useEffect(() => {
        const isFormFilled = JSON.parse(localStorage.getItem('formFilledForJob')); // Get formFilled from localStorage
        if (isFormFilled) {
            history.push('/thank-you'); // Redirect to Thank You page if form is already filled
        }
    }, [toggleForm]);
    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f5f5f5">
            <Box
                component="form"
                onSubmit={handleSubmit}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxWidth: 600,
                    width: '80%',
                    padding: '16px',
                    gap: '16px',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    backgroundColor: 'white'
                }}
            >
         <div style={{ textAlign: "center" }}>
            <img
              src={decorpotLogo}
              alt="decorpot logo"
              style={{ width: "60%", textAlign: "center" }}
            />
          </div>
                <Typography variant="h6" align="center">Job Information Form</Typography>

                <TextField
                    label="Name"
                    name="name"
                    type='text'
                    value={formData.name}
                    onChange={handleChange}
                    fullWidth
                    required
                />
                <TextField
                    label="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    type="email"
                    fullWidth
                    required
                />
                <TextField
                    label="Phone No"
                    name="mobile"
                    value={formData.mobile}
                    type="number"
                    onChange={handleChange}
                    fullWidth
                    required
                />
                <TextField
                    label="Role You're Interested In"
                    name="interestedRole"
                    value={formData.interestedRole}
                    onChange={handleChange}
                    fullWidth
                    required
                />

                <input
                    type="file"
                    onChange={onImageChange}
                    accept="application/pdf, image/*"
                    required
                />
               {formData.cvAttachment && (
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
                    <Typography variant="body2" color="textSecondary">
                        CV uploaded: <a href={formData.cvAttachment} target="_blank" rel="noopener noreferrer">View CV</a>
                    </Typography>
                    <CheckCircleIcon style={{ color: 'green', marginLeft: '8px' }} />
                </div>
            )}

                <div className="recaptcha-container">
                    <ReCAPTCHA
                        sitekey="6Le9u30qAAAAAPctnNdH11nMpOBjbl5uJPCeLJAj"
                        onChange={handleCaptchaChange}
                    />
                </div>
                <Button type="submit" variant="contained" color="primary" fullWidth disabled={!captchaValue}>
                    Submit
                </Button>
            </Box>
        </Box>
    );
};

export default connect(null, { setLoading, setSnackInfo })(JobIvrsForm);